// extracted by mini-css-extract-plugin
export default {"bgContainer":"IntroComponent_bgContainer__zB0bs"};